/* tslint:disable */
/* eslint-disable */
/**
 * smart-shop-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 계정 등록 Request
 */
export interface UserRequestCreate {
    /**
     * id
     */
    'id'?: number;
    /**
     * 로그인_아이디
     */
    'loginId'?: string;
    /**
     * 로그인_비밀번호
     */
    'loginPass'?: string;
    /**
     * 회원_명
     */
    'userNm'?: string;
    /**
     * 권한코드
     */
    'authCd'?: string;
    /**
     * 회원_휴대폰번호
     */
    'phoneNo'?: string;
    /**
     * 회사명
     */
    'compNm'?: string;
    /**
     * 소속_명
     */
    'belongNm'?: string;
    /**
     * 부서_명
     */
    'deptNm'?: string;
    /**
     * 직책_명
     */
    'positionNm'?: string;
    /**
     * 유저이미지
     */
    'fileId'?: number;
    /**
     * 연결_화주_아이디
     */
    'partnerId'?: number;
    /**
     * 로그인_실패_회수
     */
    'loginFailCnt'?: number;
    /**
     * 최근_로그인_일시
     */
    'lastLoginDateTime'?: string;
    /**
     * 최초로그인여부
     */
    'firstLoginYn'?: UserRequestCreateFirstLoginYn;
    /**
     * otp_발행번호
     */
    'otpNo'?: string;
    /**
     * otp_발생일시
     */
    'otpIssuDateTime'?: string;
    /**
     * 로그인한_유저_국가코드
     */
    'languageCode'?: string;
    /**
     * 사용자타입
     */
    'userType'?: string;
    /**
     * 등록자
     */
    'creUser'?: string;
    /**
     * 사용여부
     */
    'useYn'?: UserRequestCreateUseYn;
    /**
     * 계정잠김여부
     */
    'lockYn'?: UserRequestCreateLockYn;
    'workYmd'?: string;
    /**
     * 테마 (dark/white)
     */
    'tema'?: string;
}

export const UserRequestCreateFirstLoginYn = {
    N: 'N',
    Y: 'Y',
} as const;

export type UserRequestCreateFirstLoginYn = typeof UserRequestCreateFirstLoginYn[keyof typeof UserRequestCreateFirstLoginYn];
export const UserRequestCreateUseYn = {
    N: 'N',
    Y: 'Y',
} as const;

export type UserRequestCreateUseYn = typeof UserRequestCreateUseYn[keyof typeof UserRequestCreateUseYn];
export const UserRequestCreateLockYn = {
    N: 'N',
    Y: 'Y',
} as const;

export type UserRequestCreateLockYn = typeof UserRequestCreateLockYn[keyof typeof UserRequestCreateLockYn];


